// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".a-video--radius{overflow:hidden;border-radius:5px}.a-video__item--iframe{aspect-ratio:16/9}.a-video__iframe-player{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
